module.exports = __webpack_public_path__ + "static/media/4.e5b6a01e.png";